import { render } from "./LogOut.vue?vue&type=template&id=623e3d03&scoped=true"
import script from "./LogOut.vue?vue&type=script&lang=js"
export * from "./LogOut.vue?vue&type=script&lang=js"

import "./LogOut.vue?vue&type=style&index=0&id=623e3d03&scoped=true&lang=css"

import exportComponent from "/var/www/app/app-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623e3d03"]])

export default __exports__